import isNumeric from './isNumeric';

export default function isValidCoordinate(value: LocationCoordinates) {
  try {
    if (!value) {
      return false;
    }

    if (!isNumeric(value.latitude)) {
      return false;
    }

    if (!isNumeric(value.longitude)) {
      return false;
    }
  } catch (e) {
    // nothing
    return false;
  }

  return true;
}
